const sources = {
  viator: {
    baseUrl: "cache-graphicslib.viator.com",
    domain: "https://lpviator.imgix.net",
    regex: /http:\/\/cache-graphicslib.viator.com/,
  },
  gadventures: {
    baseUrl: "media.gadventures.com",
    domain: "https://lpgadventures.imgix.net",
    regex: /https:\/\/media.gadventures.com/,
  },
  bdc: {
    baseUrl: "aff.bstatic.com",
    domain: "https://lpbookingcom.imgix.net",
    regex: /http:\/\/aff.bstatic.com/,
  },
  hostelworld: {
    baseUrl: "ucd.hwstatic.com",
    domain: "https://lphostelworld.imgix.net",
    regex: /http:\/\/(.*)hwstatic.com/,
  },
  media: {
    baseUrl: "media.lonelyplanet.com",
    domain: "https://lonelyplanetimages.imgix.net",
    regex: /https:\/\/media.lonelyplanet.com/,
  },
};

export default function imgix(src, options = {}, source = "media") {
  if (!sources[source].regex.test(src)) {
    return src;
  }

  const url = src.replace(sources[source].regex, sources[source].domain);

  const query = Object.keys(options).map(k => `${k}=${options[k]}`).join("&");

  return `${url}${query ? `?${query}` : ""}`;
}



// WEBPACK FOOTER //
// ./assets/shared/imgix.js